import { FilePlus2, Files, FolderPlus } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { EmptyState, EmptyStateCircles, EmptyStateContent, EmptyStateDescription, EmptyStateFooter, EmptyStateTitle } from '@/components/ui/empty-state';
import { FeaturedIcon } from '@/components/ui/featured-icon';

interface FilesPageEmptyProps {
  onUploadFiles?: () => void;
  onCreateDir?: () => void;
}

export default function FilesPageEmpty(filesPageEmptyProps: FilesPageEmptyProps) {
  const { onUploadFiles, onCreateDir } = filesPageEmptyProps;

  return (
    <EmptyState>
      <EmptyStateCircles className={'z-0'} />
      <FeaturedIcon size={'lg'} className={'z-10'}>
        <Files />
      </FeaturedIcon>
      <EmptyStateContent>
        <EmptyStateTitle>Folder jest pusty</EmptyStateTitle>
        <EmptyStateDescription>Folder jest pusty dodaj plik i/lub folder</EmptyStateDescription>
        <EmptyStateFooter className={'flex-col sm:flex-row'}>
          <Button variant={'outline'} disabled={!onUploadFiles} onClick={onUploadFiles}>
            <FilePlus2 />
            Dodaj nowy plik
          </Button>
          <Button onClick={onCreateDir} variant={'outline'} disabled={!onCreateDir}>
            <FolderPlus />
            Dodaj nowy folder
          </Button>
        </EmptyStateFooter>
      </EmptyStateContent>
    </EmptyState>
  );
}
